import api from '@/api'

export default {
  namespaced: true,
  state: {
    totalSelected: 0,
    itemsSelected: [],
    fetching: false
  },
  actions: {
    async addItemBySourceAndProductId ({ state, commit, getters }, { source, productId }) {
      try {
        let product = await api.getProduct(source.type, source.identifier, productId)

        if (!product) {
          product = await api.getProductById(source.type, source.identifier, productId)
        }

        if (!product) {
          product = await api.getProductBySku(source.type, source.identifier, productId)
        }

        await this._actions['itemsSelected/add'][0](product)
      } catch (e) {
      }
    },
    async add ({ state, commit, getters }, item) {
      commit('fetching')

      let items = state.itemsSelected
      const newItem = Object.create(item)

      const alreadyAdded = items.find(item => {
        if (item.sku !== undefined) {
          return item.sku === newItem.sku
        }

        return item._id === newItem._id
      })

      if (!alreadyAdded) {
        items.push(newItem)
      }

      commit('setFetchData', {
        items
      })
    },
    async remove ({ state, commit, getters }, item) {
      commit('fetching')

      let items = []

      state.itemsSelected.forEach(function (i) {
        if (i._id !== item._id) {
          items.push(i)
        }
      })

      commit('setFetchData', {
        items
      })
    },
    async clear ({ state, commit, getters }) {
      const items = []
      commit('setFetchData', {
        items
      })
    }
  },
  getters: {
    getItemsSelected: state => () => state.itemsSelected
  },
  mutations: {
    setFetchData (state, { items }) {
      state.itemsSelected = items
      state.totalSelected = state.itemsSelected.length
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/panel/itemsSelected.js